<template>
    <div class="page" :class="{ 'no-member': !isMember }">
        <header class="header" :class="{ 'no-member': !isMember }">
            <div class="left">
                <div class="nickname">
                    <span>{{ userInfo.nickname }}</span>
                    <img
                        v-if="isMember"
                        class="nicknameLogo"
                        src="~@/assets/nickname-active-logo.png"
                        alt=""
                    />
                    <img
                        v-else
                        class="nicknameLogo"
                        src="~@/assets/nickname-logo.png"
                        alt=""
                    />
                    <div class="userId">ID:{{ userInfo.myCode }}</div>
                </div>
                <div class="bottom">
                    <div class="left">
                        <div class="box">
                            <div class="logo" @click="showOpenMember()">
                                {{
                                    isMember
                                        ? "道达赢家学员"
                                        : "获取道达赢家学员权益"
                                }}
                            </div>
                        </div>
                        <div class="expire-notice" v-if="isMember">
                            {{ userInfo.expireTime }}到期
                            <span v-if="userInfo.needRenew" @click="goPay()">
                                续费
                            </span>
                        </div>
                    </div>
                    <div class="right">
                        <img
                            v-for="item in medal"
                            :key="item"
                            class="medal"
                            :src="item"
                            alt=""
                        />
                    </div>
                </div>
            </div>
            <div class="right">
                <img class="headImg" :src="userInfo.headimgurl" alt="" />
            </div>
        </header>
        <div class="memberBox">
            <div class="myNiubiBox" @click="goNiubiDetail()">
                <img class="niubi-card" src="~@/assets/my-niubi.png" alt="" />
                <span class="myNiubi">
                    {{ userInfo.niubi }}
                    <span class="detail"> （明细） </span>
                </span>
            </div>
            <div class="youhuiquanBox">
                <div class="youhuiquan" @click="go('/coupon-list')">
                    <img
                        class="youhuiquanLogo"
                        src="~@/assets/youhuiquan-logo.png"
                        alt=""
                    />
                    <span>优惠券 {{ userInfo.coupon }}</span>
                </div>
                <div class="line"></div>
                <div class="jifen">
                    <img
                        class="jifenLogo"
                        src="~@/assets/jifen-logo.png"
                        alt=""
                    />
                    <span @click="go('/integral-detail')">
                        牛指积分
                        {{ userInfo.niuzhi && userInfo.niuzhi.score_num }}
                    </span>
                </div>
            </div>
            <div class="list">
                <div class="item" @click="showChongzhi()">
                    <img class="logo" src="~@/assets/chongzhi.png" alt="" />
                    <div>账户充值</div>
                    <div class="chongzhi-notice" v-if="ifSale">
                        <div v-for="item in giftList" :key="item.id">
                            充{{ item.fund }}送{{ item.gift }}
                        </div>
                    </div>
                </div>
                <div class="item" @click="go('/activity-list')">
                    <img class="logo" src="~@/assets/huodong.png" alt="" />
                    <div>活动报名</div>
                </div>
                <div class="item" @click="go('/ganhuo-collection')">
                    <img class="logo" src="~@/assets/shoucang.png" alt="" />
                    <div>干货收藏</div>
                </div>
                <!-- <div class="item" @click="go('/bulk-buy')">
                    <img class="logo" src="~@/assets/piliang.png" alt="" />
                    <div>批量购买</div>
                    <div class="piliang-notice">
                        <div>机构专用</div>
                    </div>
                </div> -->
                <div class="item" @click="go('/recharge')">
                    <img class="logo" src="~@/assets/mingxi.png" alt="" />
                    <div>交易明细</div>
                </div>
                <div class="item" @click="openExchangeCode()">
                    <img class="logo" src="~@/assets/tuihuanma.png" alt="" />
                    <div>兑换码激活</div>
                </div>
                <div class="item" @click="go('/zanneixin-list')">
                    <img class="logo" src="~@/assets/zhanneixin.png" alt="" />
                    <div>站内信</div>
                </div>
                <div class="item" @click="go('/help')">
                    <img class="logo" src="~@/assets/help.png" alt="" />
                    <div>联系客服</div>
                </div>
                <div class="item" @click="go('/my-comment')">
                    <img class="logo" src="~@/assets/my-comment.png" alt="" />
                    <div>我的评论</div>
                </div>
                <div class="item" @click="goPrize()" v-if="giftId">
                    <img class="logo" src="~@/assets/jiangpin.png" alt="" />
                    <div>奖品领取</div>
                </div>
            </div>
            <!-- <div class="list">
                <div class="item">
                    <div class="left">账户充值</div>
                    <div class="right">
                        <div class="chongzhi" @click="showChongzhi()">充值</div>
                    </div>
                </div>
                <div class="item" @click="go('/ganhuo-collection')">
                    <div class="left">干货收藏</div>
                    <div class="right">
                        <img
                            class="leftArrow"
                            src="~@/assets/left-arrow.png"
                            alt=""
                        />
                    </div>
                </div>
                <div class="item" @click="go('/bulk-buy')">
                    <div class="left">批量购买</div>
                    <div class="right">
                        <img
                            class="leftArrow"
                            src="~@/assets/left-arrow.png"
                            alt=""
                        />
                    </div>
                </div>
                <div class="item" @click="openExchangeCode()">
                    <div class="left">兑换码激活</div>
                    <div class="right">
                        <img
                            class="leftArrow"
                            src="~@/assets/left-arrow.png"
                            alt=""
                        />
                    </div>
                </div>
                <div class="item" @click="go('/activity-list')">
                    <div class="left">活动报名</div>
                    <div class="right">
                        <img
                            class="leftArrow"
                            src="~@/assets/left-arrow.png"
                            alt=""
                        />
                    </div>
                </div>
            </div>
            <div class="btns">
                <img
                    @click="go('/recharge')"
                    class="btn"
                    src="~@/assets/jiaoyi.png"
                    alt=""
                />
                <img
                    @click="go('/zanneixin-list')"
                    class="btn"
                    src="~@/assets/zanneixin.png"
                    alt=""
                />
                <img
                    @click="go('/help')"
                    class="btn"
                    src="~@/assets/bangzhu.png"
                    alt=""
                />
                <img
                    @click="go('/my-comment')"
                    class="btn"
                    src="~@/assets/myPinglun.png"
                    alt=""
                />
            </div> -->
        </div>
        <van-popup
            class="noMemberBox"
            v-model="isShowOpenMember"
            position="bottom"
        >
            <student-intro
                @closeStudentIntro="closeOpenMember()"
            ></student-intro>
            <div class="buyBtn" @click="goPay()">立即购买道达赢家学员</div>
        </van-popup>
    </div>
</template>
<script>
    import rx from "../../_rx";
    import userCenterService from "../../service/user-center.service";
    import studentIntro from "../../components/studentIntro/studentIntro";
    export default {
        name: "user-center",
        components: {
            "student-intro": studentIntro,
        },
        data() {
            return {
                isMember: true,
                userInfo: {},
                // saleInfo: {},
                isShowOpenMember: false,
                medal: [],
                ifSale: false,
                giftList: [],
                giftId: "",
            };
        },
        created() {
            this.getMyInfo();
            this.ifChargeSale();
        },
        activated() {
            this.getMyInfo();
            this.ifChargeSale();
        },

        methods: {
            goPrize() {
                this.$router.push({
                    path: "/get-prize-method",
                    query: { id: this.giftId },
                });
            },
            ifChargeSale() {
                userCenterService.ifChargeSale().then((res) => {
                    this.ifSale = res.data.ifSale;
                    this.giftList = res.data.list;
                });
            },
            showChongzhi() {
                rx.emit("showChongzhi");
            },
            go(path) {
                this.$router.push({ path });
            },
            getMyInfo() {
                userCenterService.getMyInfo().then((res) => {
                    this.isMember = res.data.userInfo.isMember;
                    this.userInfo = res.data.userInfo;
                    // this.saleInfo = res.data.saleInfo;
                    this.medal = res.data.medal;
                    this.giftId = res.data.gift.giftId;
                });
            },
            showOpenMember() {
                // if (isMember) {
                //     return;
                // } else {
                //     this.isShowOpenMember = true;
                // }
                this.$router.push("/pay/STUDENT?tips=1");
            },
            closeOpenMember() {
                this.isShowOpenMember = false;
            },
            openExchangeCode() {
                rx.emit("showExchangeCode");
            },
            goPay() {
                this.$router.push({ path: "/pay/STUDENT" });
            },
            goNiubiDetail() {
                this.$router.push({ path: "/niubi-detail" });
            },
        },
    };
</script>
<style lang="scss" scoped src="./user-center.scss"></style>
